"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { garagemAuth } from "@/db/auth/client";
import { toast } from "@garagem/ui/components/sonner";

// User Profile hooks
export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    // `null` clears a column; `undefined` leaves it untouched (see
    // updateUserProfileSchema).
    mutationFn: async (data: { 
      name?: string; 
      image?: string | null;
      phone?: string | null;
      creci?: string | null;
      creciType?: "pf_temporario" | "pf_definitivo" | "pj" | null;
      creciExpiryDate?: Date | null;
      cpf?: string | null;
      rg?: string | null;
      rgIssuer?: string | null;
      hireDate?: Date | null;
      jobTitle?: string | null;
      bankData?: {
        transferMethod: "pix" | "ted";
        pixKey?: string;
        bank?: string;
        bankName?: string;
        bankFullName?: string;
        agency?: string;
        account?: string;
        accountType?: "checking" | "payment" | "savings" | "salary";
      };
      metadata?: Record<string, unknown>;
    }) => {
      // Always use our custom endpoint since it handles all fields
      if (!garagemAuth?.updateUserProfile) {
        throw new Error("Update user profile API not available");
      }
      
      const response = await garagemAuth.updateUserProfile(data);
      if (response.error) throw response.error;
      return response.data;
    },
    onSuccess: () => {
      toast.success("Perfil atualizado com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["session"] });
      // Refresh the page to update session data
      window.location.reload();
    },
    onError: (error) => {
      toast.error("Falha ao atualizar perfil", {
        description: error?.message || "Ocorreu um erro ao atualizar o perfil.",
      });
    },
  });
}

